import React from 'react'
import { Link } from 'gatsby'

import { StyledButton } from '../StyledButton'

export default function Navigation({ inMenu, inHeader, pageIsDonate }) {
  const inMenuUlStyles = `flex flex-col gap-8 font-bold uppercase text-xl`
  const inMenuLiStyles = `text-white`

  const inHeaderUlStyles = `hidden md:flex flex-row items-center text-white gap-4 lg:gap-8`
  const inHeaderLiStyles = `[&>span>a]:text-white uppercase font-semibold`
  return (
    <ul
      className={`${inMenu ? inMenuUlStyles : ''} ${
        inHeader ? inHeaderUlStyles : ''
      }`}
    >
      <li
        className={`${inMenu ? inMenuLiStyles : ''} ${
          inHeader ? inHeaderLiStyles : ''
        }`}
      >
        <span className="overflow-y-hidden block">
          <Link
            to="/"
            className={`${inMenu ? 'fade-up overflow-y-hidden block' : ''}`}
            activeClassName="text-gold"
          >
            About
            <span className="sr-only">About Page</span>
          </Link>
        </span>
      </li>
      <li
        className={`${inMenu ? inMenuLiStyles : ''} ${
          inHeader ? inHeaderLiStyles : ''
        }`}
      >
        <span className="overflow-y-hidden block">
          <Link
            to="/team/"
            className={`${inMenu ? 'fade-up overflow-y-hidden block' : ''}`}
            activeClassName="text-gold"
          >
            Team
            <span className="sr-only">Team Page</span>
          </Link>
        </span>
      </li>
      <li
        className={`${inMenu ? inMenuLiStyles : ''} ${
          inHeader ? inHeaderLiStyles : ''
        }`}
      >
        <span className="overflow-y-hidden block">
          <Link
            to="/media/"
            className={`${inMenu ? 'fade-up overflow-y-hidden block' : ''}`}
            activeClassName="text-gold"
          >
            Media
            <span className="sr-only">Media Page</span>
          </Link>
        </span>
      </li>
      <li
        className={`${inMenu ? inMenuLiStyles : ''} ${
          inHeader ? inHeaderLiStyles : ''
        }`}
      >
        <span className="overflow-y-hidden block">
          <Link
            to="/sign-up/"
            className={`${inMenu ? 'fade-up overflow-y-hidden block' : ''}`}
            activeClassName="text-gold"
          >
            Sign up
            <span className="sr-only">Sign Up Page</span>
          </Link>
        </span>
      </li>
      {!pageIsDonate && (
        <li
          className={`${inMenu ? inMenuLiStyles : ''} ${
            inHeader ? inHeaderLiStyles : ''
          }`}
        >
          <span className="overflow-y-hidden block">
            <StyledButton
              text="Donate"
              internal
              to="/donate/"
              className={`${inMenu ? 'fade-up block' : 'p-0 m-0 text-black'}`}
            >
              <span className="sr-only">Sign Up Page</span>
            </StyledButton>
          </span>
        </li>
      )}
    </ul>
  )
}
